import { imgUrl } from "@/lib/api";
import { inr } from "@/lib/format";

export const OrderLines = ({ lines = [] }) => (
  <ul className="divide-y divide-slate-100" data-testid="order-lines">
    {lines.map((l) => (
      <li key={l.product_id} className="flex items-center gap-4 py-4">
        {l.image && <img src={imgUrl(l.image)} alt="" loading="lazy" className="h-16 w-16 shrink-0 rounded-xl object-cover ring-1 ring-slate-200" />}
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-brand-ink">{l.name}</p>
          <p className="text-sm text-slate-600">{inr(l.unit_price)} × {l.qty}</p>
        </div>
        <p className="font-semibold text-brand-ink">{inr(l.line_total)}</p>
      </li>
    ))}
  </ul>
);

export const Totals = ({ subtotal, shipping, total, totalLabel = "Total" }) => (
  <dl className="space-y-2 text-base">
    <div className="flex justify-between"><dt className="text-slate-600">Subtotal</dt><dd data-testid="summary-subtotal">{inr(subtotal)}</dd></div>
    <div className="flex justify-between"><dt className="text-slate-600">Shipping</dt><dd data-testid="summary-shipping">{shipping ? inr(shipping) : "Free"}</dd></div>
    <div className="flex justify-between border-t border-slate-200 pt-3 text-lg font-bold text-brand-ink"><dt>{totalLabel}</dt><dd data-testid="summary-total">{inr(total)}</dd></div>
  </dl>
);
